import { debounce } from 'lodash';
import { commas } from '../../../../src/helpers';

export default {
    data() {
        return {
            insights: {
                metrics: {
                    impressions: '',
                    reach: '',
                    replies: '',
                    taps_forward: '',
                    taps_back: '',
                    exits: ''
                },
                errors: {},
                sending: false
            },
            debouncedformatMetric: debounce(() => {
                for (const key in this.insights.metrics) {
                    const formatted = commas(this.cleanMetric(this.insights.metrics[key]));
                    this.insights.metrics[key] = formatted;
                }
            }, 300)
        };
    },

    computed: {
        insightsIsReady() {
            if (
                !this.isValidMetric(this.insights.metrics.impressions) ||
                !this.isValidMetric(this.insights.metrics.reach) ||
                !this.isValidMetric(this.insights.metrics.replies) ||
                !this.isValidMetric(this.insights.metrics.taps_forward) ||
                !this.isValidMetric(this.insights.metrics.taps_back) ||
                !this.isValidMetric(this.insights.metrics.exits) ||
                !this.hasUploadedFiles
            ) {
                return false;
            }
            return true;
        }
    },

    methods: {
        resetInsights() {
            this.insights.metrics = {
                impressions: '',
                reach: '',
                replies: '',
                taps_forward: '',
                taps_back: '',
                exits: ''
            };
        },
        isValidMetric(metric) {
            return metric || metric === 0;
        },
        cleanMetric(metric) {
            const num = ('' + metric).replace(/[^0-9]/gi, '');
            return num || num === 0 ? parseInt(num) : '';
        },
        getMetricsWithoutCommas() {
            const metrics = {};
            for (const key in this.insights.metrics) {
                metrics[key] = this.cleanMetric(this.insights.metrics[key]);
            }

            return metrics;
        }
    },
    watch: {
        insights: {
            deep: true,
            handler() {
                this.debouncedformatMetric();
            }
        }
    }
};
